import React from 'react'
import "../../App.css";
import { Bar } from 'react-chartjs-2'
import Card from '../../components/Custom/Card/Card';
import CardBody from '../../components/Custom/Card/CardBody';
 

const BarChart = (props) => {  
			const month = [];
			const monthTxn = [];
			if(props.monthSummary!= null )props.monthSummary.map((r) => { month.push(r.month); monthTxn.push(r.successfulTxnAmount)});
	
  return (
    <Card color="white">
    <CardBody>
 	 
      <Bar
      
        data={{
         
          labels: month,
          datasets: [
            {
              
              label: 'Sales Chart',
              data: monthTxn,
              backgroundColor:  '#234B77',
              borderColor: 'black',
            },
             
          ],
        }}
        height={300}  
 		width={420}
        options={{
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              barThickness: 50,
              maxBarThickness: 50,
              width:20
            }],
            yAxes: [
              
              {
                
                ticks: {
                  
                  beginAtZero: true,
                },
              },
            ],
          },
          legend: {
            position: 'bottom',
            
            labels: {
              fontSize: 25,
            },
          },
        }}
      />
   
   </CardBody>
    </Card>
  )
}

export default BarChart